import { TargetUnit } from '../../services/modules/target/target.types';
import { formatLocaleAbreviatedNumber } from '../../utils/formatters';
import { TARGET_EMPTY_VALUE } from './target.constants';
import {
  FormatAbreviatedTargetValueParams,
  FormatTargetShareParams,
  FormatTargetValueParams,
} from './targetValue.types';

const MONEY_UNITS = [TargetUnit.GROSS_MONEY, TargetUnit.NET_MONEY];

export const TARGET_SHARE_DECIMAL_SCALE = 2;

export const isMoneyUnit = (unit?: TargetUnit) => !!unit && MONEY_UNITS.includes(unit);

export const toTargetShare = ({ value, plannedTotal }: FormatTargetShareParams) => {
  const total = Number(plannedTotal);

  if (!value || !plannedTotal || total === 0) {
    return undefined;
  }

  const share = (Number(value) / total) * 100;

  return Number(share.toFixed(TARGET_SHARE_DECIMAL_SCALE));
};

export const formatTargetShare = ({ value, plannedTotal, locale }: FormatTargetShareParams) => {
  const share = toTargetShare({ value, plannedTotal });

  if (share === undefined) {
    return TARGET_EMPTY_VALUE;
  }

  return `${share.toLocaleString(locale, {
    minimumFractionDigits: TARGET_SHARE_DECIMAL_SCALE,
    maximumFractionDigits: TARGET_SHARE_DECIMAL_SCALE,
  })}%`;
};

export const formatTargetValue = ({
  value,
  unit,
  locale,
  formatMoney,
}: FormatTargetValueParams) => {
  if (!value) {
    return TARGET_EMPTY_VALUE;
  }

  if (isMoneyUnit(unit)) {
    return formatMoney(Number(value));
  }

  return Number(value).toLocaleString(locale, { maximumFractionDigits: 0 });
};

export const formatAbreviatedTargetValue = ({
  value,
  unit,
  locale,
  formatAbreviatedMoney,
}: FormatAbreviatedTargetValueParams) => {
  if (!value) {
    return TARGET_EMPTY_VALUE;
  }

  if (isMoneyUnit(unit)) {
    return formatAbreviatedMoney(Number(value));
  }

  return formatLocaleAbreviatedNumber(Math.round(Number(value)), locale);
};
